import React from 'react'

const _NotFound = () => {
  return (
    <div>404 Page not found.</div>
  )
}

export default _NotFound